import React from "react";

function IconMatchingBuyers() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
      <path d="M9.625 14.962c0-.724.588-1.312 1.313-1.312h2.625c.725 0 1.313.588 1.313 1.312v.876a.437.437 0 0 1-.438.437H9.625v-1.313Z" />
      <path d="M10.938 12.337a1.313 1.313 0 1 1 2.625 0 1.313 1.313 0 0 1-2.625 0ZM6.125 14.962c0-.724.588-1.312 1.313-1.312h2.625c.725 0 1.312.588 1.312 1.312v.876a.437.437 0 0 1-.437.437H6.125v-1.313Z" />
      <path d="M7.438 12.337a1.313 1.313 0 1 1 2.625 0 1.313 1.313 0 0 1-2.625 0ZM2.625 14.962c0-.724.588-1.312 1.313-1.312h2.625c.725 0 1.312.588 1.312 1.312v1.313H3.063a.437.437 0 0 1-.438-.437v-.876Z" />
      <path d="M3.938 12.337a1.313 1.313 0 1 1 2.625 0 1.313 1.313 0 0 1-2.625 0Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.607 4.204a.656.656 0 0 1 .027.927l-3.301 3.5a.656.656 0 0 1-.908.046L5.914 7.364a.656.656 0 1 1 .86-.99l1.036.899 2.87-3.042a.656.656 0 0 1 .927-.027Z"
      />
    </svg>
  );
}

export default IconMatchingBuyers;
